/* ============================================================
   CARMOODS ARTICLE ENHANCEMENTS — carmoods-article.js
   Load in sections/main-article.liquid:
     <script src="{{ 'carmoods-article.js' | asset_url }}" defer></script>
   1. Reading progress bar (top of viewport)
   2. FAQPage JSON-LD generated from the .cma-faq accordion
   3. Auto-assigns ids to H2s + .cma-anchor scroll margin,
      so TOC links work even if a writer forgets the id.
   ============================================================ */
(function () {
  'use strict';

  var content = document.querySelector('.article-template__content, .article-template, article');
  if (!content) return;

  /* ---- 1. Reading progress bar ---- */
  var bar = document.createElement('div');
  bar.className = 'cma-progress';
  bar.setAttribute('aria-hidden', 'true');
  document.body.appendChild(bar);

  function updateBar() {
    var rect = content.getBoundingClientRect();
    var total = rect.height - window.innerHeight;
    var scrolled = Math.min(Math.max(-rect.top, 0), Math.max(total, 1));
    bar.style.width = (total > 0 ? (scrolled / total) * 100 : 0) + '%';
  }
  window.addEventListener('scroll', updateBar, { passive: true });
  window.addEventListener('resize', updateBar);
  updateBar();

  /* ---- 2. FAQ structured data (FAQPage JSON-LD from .cma-faq details) ---- */
  var faqs = [];
  content.querySelectorAll('.cma-faq details').forEach(function (d) {
    var q = d.querySelector('summary');
    var a = d.querySelector('p');
    if (q && a && q.textContent.trim() && a.textContent.trim()) {
      faqs.push({
        '@type': 'Question',
        name: q.textContent.trim(),
        acceptedAnswer: { '@type': 'Answer', text: a.textContent.trim() }
      });
    }
  });
  if (faqs.length > 0 && !document.querySelector('script[data-cma-faq-schema]')) {
    var ld = document.createElement('script');
    ld.type = 'application/ld+json';
    ld.setAttribute('data-cma-faq-schema', '1');
    ld.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs
    });
    document.head.appendChild(ld);
  }

  /* ---- 3. Heading anchors for the table of contents ---- */
  var slugCounts = {};
  content.querySelectorAll('h2').forEach(function (h) {
    h.classList.add('cma-anchor');
    if (!h.id) {
      var slug = h.textContent.trim().toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .slice(0, 60) || 'section';
      if (slugCounts[slug]) { slugCounts[slug]++; slug += '-' + slugCounts[slug]; } else { slugCounts[slug] = 1; }
      h.id = slug;
    }
  });
})();
